import { Market } from '../types/market'

/**
 * Formats an amount in the market's own currency, using the currency and
 * locale Shopify serves for that market. No conversion happens here.
 */
export function formatLocal(amount: number, market: Market): string {
  const decimals = market.roundTo >= 1 ? 0 : 2

  try {
    return new Intl.NumberFormat(market.locale, {
      style: 'currency',
      currency: market.currency,
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals,
    }).format(amount)
  } catch {
    return `${amount.toFixed(decimals)} ${market.currency}`
  }
}

/**
 * Estimated reference values (bonuses, pack value) are expressed in USD.
 * They are shown in the visitor's currency using the ratio implied by
 * SHOPIFY'S OWN localized price for this market (local price ÷ the USD price
 * of the same variant) — never an external exchange rate — and rounded to a
 * readable step. These are reference values only; the product price always
 * comes straight from Shopify.
 */
export function estimatedAmount(usd: number, market: Market): number {
  const reference = market.usdReference > 0 ? market.usdReference : 1
  const ratio = market.priceAmount / reference
  const raw = usd * ratio
  return Math.round(raw / market.roundTo) * market.roundTo
}

export function estimatedInMarket(usd: number, market: Market): string {
  return formatLocal(estimatedAmount(usd, market), market)
}
